import { z} from "zod"

export const ZTag = z.object({
  id: z.number(),
  name: z.string(),
})

export type Tag = z.infer<typeof ZTag>
